import axios from "axios";

export default function getAllAvailableBranchesForRules(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/account/api/v1/branch-group/get-all-branch?node_uuid=${parameters.nodeUuid}&search=${parameters.search}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
